/**
 * Paths that host the YouTube analysis modal: the canonical slug page, its
 * `/keypoint/<id>` share route, the `by-url` alias, and the `@modal`
 * intercept. While the URL is one of these, the modal is open.
 */
export const isVideoAnalysisPath = (pathname: string | null): boolean =>
  pathname != null && pathname.startsWith('/videos/youtube/');

/**
 * Paths that host the article analysis modal: the canonical
 * `/articles/<slug>` page, the `@modal` intercept of it, and the
 * `/articles/by-url` alias. Never the `/articles` hub itself.
 */
export const isArticleAnalysisPath = (pathname: string | null): boolean =>
  pathname != null && /^\/articles\/[^/]+\/?$/.test(pathname);

/** Either analysis modal's paths. */
export const isAnalysisPath = (pathname: string | null): boolean =>
  isVideoAnalysisPath(pathname) || isArticleAnalysisPath(pathname);
